import React, {useEffect, useState} from 'react';

const MerchantOrderTable = ({orders, processing, filter}) => {


    // Состояние для отслеживания нажатой кнопки копирования
    const [copiedIndex, setCopiedIndex] = useState({});

    const handleCopy = (traderId, index, direction) => {
        navigator.clipboard.writeText(traderId);
        setCopiedIndex({index, direction});
        setTimeout(() => setCopiedIndex({}), 2000); // Возвращаем текст обратно через 2 секунды
    };


    useEffect(() => {

        if(copiedIndex.index) {
            setCopiedIndex(prev => {
                return {
                    ...prev,
                    index: prev.index + 1
                }
            })
        }

    }, [orders])
    return (
        orders.length
            ?
            <table className="transaction-table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Дата</th>
                    <th>Сумма (руб)</th>
                    {/*<th>Сумма (usdt)</th>*/}
                    <th>Статус</th>
                    <th className={"fixed-table-width"}>Профит (usdt)</th>
                    <th className={"fixed-table-width"}>Copy ID</th>

                </tr>
                </thead>
                <tbody>
                {orders?.map((order, index) => {
                    // const formattedDate = new Date(card.block_timestamp)
                    //     .toLocaleString('ru-RU', options);
                    console.log(order)

                    if(filter.number && parseFloat(filter.number) !== order.number && filter.number !== order.id && filter.number.toString() !== order.external_id) {
                        return
                    }
                    if(filter.status && filter.status !== order.status) return
                    if(filter.amount && filter.amount !== order.amount) return

                    return (
                        <tr
                            key={order._id}
                            className={
                                order.status === "failed"
                                    ?
                                    "red-row"
                                    :
                                    order.status === "opened"
                                        ?
                                        "green-row"
                                        :
                                        order.status === "appealing"
                                            ?
                                            "orange-row"
                                            :
                                            index % 2 === 0
                                                ?
                                                'even-row'
                                                :
                                                'odd-row'
                            }
                        >
                            <td>{order.number}</td>
                            <td>{new Date(order.openDate).toLocaleString([], {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: '2-digit',
                                minute: '2-digit'
                            })}</td>
                            <td>{order.amount}</td>
                            {/*<td>{order.usdtAmountBybit?.toFixed(2)}</td>*/}
                            <td>{order.status}</td>
                            <td>{order.merchantProfit?.toFixed(2)}</td>
                            <td
                                className={"flex-table-cell"}

                            >

                                <button
                                    style={{"minWidth": "30px", "minHeight": "30px", "fontSize": "10px"}}
                                    className={"copy-id-btn"}
                                    onClick={() => handleCopy(order.id || order._id, index, "in")}
                                >
                                    {copiedIndex.index === index && copiedIndex.direction === "in" ? '✔️' : '𝓣'}
                                </button>

                                <button
                                    style={{"minWidth": "30px", "minHeight": "30px", "fontSize": "10px"}}
                                    className={"copy-id-btn"}
                                    onClick={() => handleCopy(order.external_id, index, "out")}
                                >
                                    {copiedIndex.index === index && copiedIndex.direction === "out" ? '✔️' : '𝓜'}
                                </button>

                            </td>

                        </tr>
                    );
                })}
                </tbody>
            </table>
            :
            processing
                ?
                <img src={require('../../img/loading.gif')} height={"40px"}
                     className={"margin-left-20"}/>
                :
                <h2>Нет ничего соответствующего вашему запросу</h2>

    );
};

export default MerchantOrderTable;